import { deviceManager, isElectron, isMac, isWindows } from "../../libs/roomnew";

export default class DeviceWizard{
    constructor(lobby){
        this.lobby=lobby;
        this.shown=false;
        this.wizardModal=$("#devicesSetupModal");
        this.closeWizardButton=$("#closeDevicesWizardButton");
        //tabs
        this.speakersTab=$("#wizard-speakers");
        this.microphoneTab=$("#wizard-microphone");
        this.cameraTab=$("#wizard-camera");

        //tab icon
        this.speakersTabIcon=$("#wizard-speakers-tab");
        this.microphoneTabIcon=$("#wizard-microphone-tab");
        this.cameraTabIcon=$("#wizard-camera-tab");
        //next buttons
        this.speakersNextButton=$("#wizard-speakers-next");
        this.microphoneNextButton=$("#wizard-microphone-next");
        this.cameraNextButton=$("#wizard-camera-next");

        //back buttons
        this.micBackButton=$("#mic-back-button");
        this.cameraBackButton=$("#camera-back-button");

        //devices list buttons
        this.speakerButton=$("#wizard-speaker-button");
        this.microphoneButton=$("#wizard-microphone-button");
        this.cameraButton=$("#wizard-camera-button");

        //devices list dropdown
        this.speakersList=$("#wizard-speakers-list");
        this.microphonesList=$("#wizard-microphones-list");
        this.camerasList=$("#wizard-cameras-list");

        //volume bars
        this.speakerBars=$("#wizard-speaker-bars");
        this.microphoneBars=$("#wizard-microphone-bars");

        //test speakers button
        this.testSpeakersButton=$("#wizard-test-speakers-btn");
        this.testAudio;
        this.testBarsAudio;
        this.playAudioIcon = `<svg class="test-output-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 485 485" xml:space="preserve"><g><path d="M413.974,71.026C368.171,25.225,307.274,0,242.5,0S116.829,25.225,71.026,71.026C25.225,116.829,0,177.726,0,242.5s25.225,125.671,71.026,171.474C116.829,459.775,177.726,485,242.5,485s125.671-25.225,171.474-71.026C459.775,368.171,485,307.274,485,242.5S459.775,116.829,413.974,71.026z M242.5,455C125.327,455,30,359.673,30,242.5S125.327,30,242.5,30S455,125.327,455,242.5S359.673,455,242.5,455z"/><polygon points="181.062,336.575 343.938,242.5 181.062,148.425 	"/></g></svg>`;
        this.stopAudioIcon = `<svg class="test-output-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve"><path d="M500,10C229.4,10,10,229.4,10,500s219.4,490,490,490s490-219.4,490-490S770.6,10,500,10z M500,928.7C263.6,928.7,71.3,736.4,71.3,500C71.3,263.6,263.6,71.3,500,71.3c236.4,0,428.7,192.3,428.7,428.7C928.7,736.4,736.4,928.7,500,928.7z"></path><path d="M622.5,316.2h-245c-33.8,0-61.2,27.4-61.2,61.2v245c0,33.8,27.4,61.3,61.2,61.3h245c33.8,0,61.3-27.4,61.3-61.3v-245C683.7,343.7,656.3,316.2,622.5,316.2z"></path></svg>`;

        this.speakersConfirmMusicYes=$("#speakers-music-confirm-yes");
        this.speakersConfirmMusicNo=$("#speakers-music-confirm-no");
        this.speakersConfirmMusicPrompt=$("#speakers-music-confirm");
        this.speakersAfterConfirmMessage=$("#speakers-after-confirm-message");

        //camera preview video element
        this.cameraPreview=document.getElementById('wizard-camera-preview-video');


        //variables
        this.selectedSpeakerId;
        this.selectedMicId;
        this.selectedCameraId;

        //
        this.capturedAudio;
        this.capturedVideo;

        this.dropDownArrow=`<svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1.175L8.825 -5.13609e-08L5 3.81667L1.175 -3.85753e-07L-5.13609e-08 1.175L5 6.175L10 1.175Z" ></path></svg>`;

        //error messages
        this.speakerMessage=$("#wizard-speaker-message");
        this.micMessage=$("#wizard-microphone-message");
        this.cameraMessage=$("#wizard-camera-message");



        this.playIcon=`<svg class="svg-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M213.333333 189.226667v645.546666a42.666667 42.666667 0 0 0 66.005334 35.712l493.397333-322.773333a42.666667 42.666667 0 0 0 0-71.424L279.338667 153.514667A42.666667 42.666667 0 0 0 213.333333 189.226667z" /></svg>`;
        this.pauseIcon=`<svg class="svg-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M277.333333 213.333333v607.146667a42.666667 42.666667 0 0 0 42.666667 42.666667H384a42.666667 42.666667 0 0 0 42.666667-42.666667V213.333333a42.666667 42.666667 0 0 0-42.666667-42.666666H320a42.666667 42.666667 0 0 0-42.666667 42.666666zM597.333333 213.333333v607.146667a42.666667 42.666667 0 0 0 42.666667 42.666667h64a42.666667 42.666667 0 0 0 42.666667-42.666667V213.333333a42.666667 42.666667 0 0 0-42.666667-42.666666H640a42.666667 42.666667 0 0 0-42.666667 42.666666z"/></svg>`;

        this.playerPlayPause=$("#player-play-pause");
        this.playerSeekSlider=$("#player-audio-slider");


        //mic selection
        this.micSelectionSection=$("#wizard-mic-selection-section");
        this.detectingMicMessage=$("#detecting-mic-message");
        this.micDetectionFailed=$("#mic-detection-failed");

        this.micBarsConfirm=$("#mic-bars-confirm");
        this.micAfterConfirmMessage=$("#mic-after-confirm-message");

        this.micBarsConfirmYes=$("#mic-bars-confirm-yes");
        this.micBarsConfirmNo=$("#mic-bars-confirm-no")
        this.musicConfirmPromptTimeout=0;
        this.detectingMicrophoneTimeout=0;
        this.micBarsConfirmTimeout=0;
    };

    buttonEvents(){
        let wizard=this;
        //next buttons events
        this.speakersNextButton.on('click',this.wizardMicrophone.bind(wizard));
        this.microphoneNextButton.on('click',this.wizardCamera.bind(wizard));
        this.cameraNextButton.on('click',this.wizardFinish.bind(wizard));
        this.testSpeakersButton.on('click',()=>{
            if(wizard.audioPlaying){
                wizard.stopTestAudio();
            }else{
                wizard.playTestAudio();
            }
        });

        this.speakerButton.on('click',()=>{
            this.speakerButton.removeClass('pulse-button-red');
            if(!this.speakersList.hasClass('show')){
                this.listSpeakers();
            }
        });
        this.microphoneButton.on('click',()=>{
            this.microphoneButton.removeClass('pulse-button-red');
            if(!this.microphonesList.hasClass('show')){
                this.listMicrophones();
            }
        })
        this.cameraButton.on('click',()=>{
            if(!this.camerasList.hasClass('show')){
                this.listCameras();
            }
        })


        this.closeWizardButton.on('click',this.wizardClose.bind(wizard));

        this.playerPlayPause.on('click',()=>{
            if(wizard.audioPlaying){
                wizard.stopTestAudio();
            }else{
                wizard.playTestAudio();
            }
        });

        this.speakersConfirmMusicNo.on('click',(e)=>{
            e.preventDefault();
            this.speakerButton.addClass('pulse-button-red');
            this.hideMusicConfirmPrompt();
            this.setAfterConfirmMessage(`Please change the speakers above and try again`)
            this.disableSpeakersNextButton();
            this.stopTestAudio();
        });
        this.speakersConfirmMusicYes.on('click',(e)=>{
            e.preventDefault();
            this.hideMusicConfirmPrompt();
            this.enableSpeakersNextButton();
            this.stopTestAudio();
        });

        this.micBarsConfirmYes.on('click',()=>{
            this.hideMicBarsMovingPrompt();
            this.enableMicNextButton();
            this.clearMicErrors();
        });

        this.micBarsConfirmNo.on('click',()=>{
            this.microphoneButton.addClass('pulse-button-red');
            this.hideMicBarsMovingPrompt();
            this.clearMicErrors();
            this.disableMicNextButton();
            this.setMicAfterConfirmMessage(`Please change microphone above and try again`);
        });

        this.micBackButton.on('click',()=>{
            this.wizardSpeakers();
        });
        this.cameraBackButton.on('click',()=>{
            this.wizardMicrophone();
        })
    };

    deviceListChanged(){
        // console.log("Devices list has changed",event)
        if(this.speakersTab.hasClass('active')){
            this.listSpeakers();
        }
        if(this.microphoneTab.hasClass('active')){
            this.listMicrophones();
        }
        if(this.cameraTab.hasClass('active')){
            this.listCameras();
        }
    }

    makeTabActive(tabName){
        $("#devices-wizard").find('.wizard-content-tab').removeClass('active');
        $(`#wizard-${tabName}`).addClass('active');
        if(tabName=="microphone"){
            this.microphoneTabIcon.addClass('active');
            $("#connect-microphone").addClass('active')

            this.cameraTabIcon.removeClass('active');
            $("#connect-camera").removeClass('active')
            this.microphoneTabIcon.off('click');
            this.cameraTabIcon.off('click');
            this.speakersTabIcon.off('click');
            this.speakersTabIcon.on('click',()=>{
                this.wizardSpeakers();
            });
        }else if(tabName=="camera"){
            this.cameraTabIcon.addClass('active');
            $("#connect-camera").addClass('active')
            this.microphoneTabIcon.off('click');
            this.cameraTabIcon.off('click');
            this.speakersTabIcon.off('click');

            this.speakersTabIcon.on('click',()=>{
                this.wizardSpeakers();
            });
            this.microphoneTabIcon.on('click',()=>{
                this.wizardMicrophone();
            });
        }else{
            this.microphoneTabIcon.removeClass('active');
            $("#connect-microphone").removeClass('active')

            this.cameraTabIcon.removeClass('active');
            $("#connect-camera").removeClass('active')
            this.microphoneTabIcon.off('click');
            this.cameraTabIcon.off('click');
            this.speakersTabIcon.off('click');
        }
    };

    showWizard(){
        this.buttonEvents();
        this.getSelectedDevices();
        this.wizardModal.modal('show');
        this.wizardSpeakers();
        this.shown=true;
    }

    getSelectedDevices(){
        this.selectedMicId=deviceManager.lastUsedMic();
        this.selectedCameraId=deviceManager.lastUsedCamera();
        this.selectedSpeakerId=deviceManager.lastUsedSpeaker();
    }
    wizardSpeakers(){
        this.listSpeakers();
        this.destroyInstanceOfMics();
        this.createTestSpeakerAudio();
        this.tryChangeSpeakerId(this.selectedSpeakerId);
        this.hideAfterConfirmMessage();
        this.hideMusicConfirmPrompt();
        // this.disableSpeakersNextButton();
        // this.tryMicrophoneDevice(this.selectedMicId);
        this.makeTabActive('speakers');
        this.stopTracks(this.capturedAudio);
        this.capturedAudio=null;
        this.setMicrophoneOff();
        this.stopTracks(this.capturedVideo);
        this.capturedVideo=undefined;
        this.setCameraOff();

    };
    wizardMicrophone(){
        // this.destroyInstanceofSpeakers();
        this.suspendSpeakersAudioContext();
        this.stopTestAudio();
        this.micSelectionSection.addClass('d-none');
        this.detectingMicMessage.removeClass('d-none');
        this.micDetectionFailed.addClass('d-none');
        this.makeTabActive('microphone');
        this.tryMicrophoneDevice(this.selectedMicId);
        this.listMicrophones();

        this.stopTracks(this.capturedVideo);
        this.capturedVideo=undefined;
        this.setCameraOff();

    };
    wizardCamera(){
        this.destroyInstanceOfMics();
        this.tryCameraDevice(this.selectedCameraId);
        this.listCameras();
        this.makeTabActive('camera');
    };

    wizardFinish(){
        this.lobby.setDeviceSettings({
            audioDeviceId:this.selectedMicId,
            cameraDeviceId: this.selectedCameraId,
            speakerDeviceId: this.selectedSpeakerId
        });
        this.wizardClose();
    };

    wizardClose(){
        this.shown=false;
        this.setWizardShown();
        this.wizardModal.modal('hide');
        this.stopTracks(this.capturedAudio);
        this.stopTracks(this.capturedVideo);
        this.stopTestAudio();
        this.destroyAudioFiles();
        this.destroyInstanceofSpeakers();
        this.setMicrophoneOff();
        this.setCameraOff();
        setTimeout(() => {
            this.wizardModal.remove();
        }, 400);
    }
    //speaker functions
    listSpeakers(){
        this.speakersList.html('<h6 class="dropdown-header px-2">Speaker devices</h6>');

        deviceManager.getSpeakers().then(speakers=>{

            speakers.forEach(device => {
                let isSelected='';
                if(!device.deviceId){return}
                if (this.selectedSpeakerId == device.deviceId) {
                    isSelected = "selected";
                }
                let option=$("<a/>",{
                    class:`dropdown-item lobby-dropdown-item ${isSelected}`,
                    href:'#',
                    'device-id':device.deviceId,
                    html:`<i class="fas fa-volume-up mr-1"></i> ${device.label}`
                }).on('click',(e)=>{
                    e.preventDefault();
                    this.stopTestAudio();
                    this.tryChangeSpeakerId(device.deviceId,true);
                });
                this.speakersList.append(option);
            });
            if(speakers&&speakers.length){
                if(!this.selectedSpeakerId){
                    this.tryChangeSpeakerId('default');
                }
            }else if(speakers.length==0){
                this.speakersList.append($("<a/>",{
                    class:`dropdown-item lobby-dropdown-item`,
                    href:'#',
                    html:`No speakers found`
                }));
            }
        });
    };
    tryChangeSpeakerId(id,autoPlayAudio=false){
        this.hideMusicConfirmPrompt();
        this.testAudio.setSinkId(id).then(()=>{
            this.selectedSpeakerId=id;
            console.log("Speaker device changed for audio",id);
            this.setSelectedSpeakerName(id);
            this.clearSpeakerErrors();
            if(autoPlayAudio){
                this.playTestAudio();
            }
        }).catch((err)=>{
            console.error("could not set selected speaker",err)
            this.disableSpeakersNextButton();
            // this.selectedSpeakerId=false;
            this.speakerButton.html(`Select speaker device ${this.dropDownArrow}`)
        });
    };

    playAudio(){
        try {
            this.testAudio.play()
            this.testBarsAudio.play();
        } catch (error) {
            console.error("Audio play error",error)
        }
    }
    pauseAudio(){
        try {
            this.testAudio.pause()
            this.testBarsAudio.pause();
        } catch (error) { console.error("[Kino Error] [DevicesWizard]", error); }
    }
    createTestSpeakerAudio(){
        if(this.testAudio){
            this.testAudio.currentTime=0;
            this.testBarsAudio.currentTime=0;
            return
        }
        this.testAudio=new Audio();
        this.testAudio.src= `${isElectron ? api.global.app_url : '' }/sounds/test-output.mp3`;
        // this.testAudio.autoplay="autoplay";

        this.testBarsAudio = new Audio();
        this.testBarsAudio.src = `${isElectron ? api.global.app_url : '' }/sounds/test-output.mp3`;
        $(document).on('mousemove',()=>{
            if(this.testAudio && !this.autoplayOn && !this.audioPlaying && this.selectedSpeakerId){
                this.playAudio();
                this.autoplayOn=true;
            }
        })
        this.testBarsAudio.onplaying=()=>{
            console.log("Playing test bars audio")
            if(!this.speakerAudioContext){
                this.connectSpeakerToBars();
            }else{
                this.resumeSpeakersAudioContext();
            }
        };
        this.testAudio.addEventListener('loadedmetadata', () => {
            this.initAudioPlayer();
                // this.testAudio.play();
                if(this.selectedSpeakerId){
                    this.playAudio();
                }
          });
        this.testAudio.addEventListener('timeupdate', () => {
            this.playerSeekSlider.val(Math.floor(this.testAudio?.currentTime??0));
          });
        this.audioPlaying=false;
        this.testAudio.onplaying=()=>{
            this.autoplayOn=true;
            // this.testSpeakersButton.html(`${this.stopAudioIcon} STOP TEST`);
            this.showMusicConfirmPrompt();
            this.playerPlayPause.html(this.pauseIcon);
            this.playerPlayPause.attr('title','Stop test');
            this.playerPlayPause.attr('data-original-title','Stop test')
            this.audioPlaying=true;

        };
        this.testAudio.onended = (event) => {
            this.testSpeakersButton.html(`${this.playAudioIcon} TEST SPEAKERS`);
            this.audioPlaying=false;
            this.testAudio.currentTime=0;
            this.playerPlayPause.html(this.playIcon);
            // this.playerPlayPause.attr('title','Test Speakers');
            this.playerPlayPause.attr('data-original-title','Test Speakers')
            this.suspendSpeakersAudioContext();
        };
        this.playerSeekSlider.on('input',()=>{
            console.log("Slider val is ",this.playerSeekSlider.val())
            try {
                this.testAudio.currentTime=parseInt(this.playerSeekSlider.val());
                this.testBarsAudio.currentTime=parseInt(this.playerSeekSlider.val());
            } catch (error) { console.error("[Kino Error] [DevicesWizard]", error); }
        })

        // this.connectSpeakerToBars();
    };

    initAudioPlayer(){
        this.playerSeekSlider.attr('max',this.testAudio.duration);
    };

    showMusicConfirmPrompt(){
        this.hideAfterConfirmMessage();
        clearTimeout(this.musicConfirmPromptTimeout);
        this.musicConfirmPromptTimeout=setTimeout(() => {
            this.speakersConfirmMusicPrompt.removeClass('d-none');
        }, 1000);
        this.disableSpeakersNextButton();

    };
    hideMusicConfirmPrompt(){
        clearTimeout(this.musicConfirmPromptTimeout);
        this.speakersConfirmMusicPrompt.addClass('d-none');
    };

    setAfterConfirmMessage(message){
        this.speakersAfterConfirmMessage.find(".wizard-label").html(message);
        this.speakersAfterConfirmMessage.removeClass('d-none');
    };

    hideAfterConfirmMessage(){
        this.speakersAfterConfirmMessage.addClass('d-none');
        this.speakersAfterConfirmMessage.find(".wizard-label").html('');
    }

    destroyInstanceofSpeakers(){
        let ds = this;
        if(ds.speakerAudioContext){
            ds.speakerAudioContext.close();
            ds.speakerAudioContext=null;
        }
        this.colorSpeakerPids(0);

    }

    destroyAudioFiles=()=>{
        try{
            this.testAudio.src="";
            this.testBarsAudio.src="";
            this.testAudio.play();
            this.testBarsAudio.play();
            this.testAudio=null;
            this.testBarsAudio=null;
        } catch (error) { console.error("[Kino Error] [DevicesWizard]", error); }

    }

    resumeSpeakersAudioContext(){
        if(!this.speakerAudioContext){return}
        this.speakerAudioContext.resume();
    };

    suspendSpeakersAudioContext(){
        if(!this.speakerAudioContext){return}
        this.speakerAudioContext.suspend();
        this.colorSpeakerPids(0)
    };


    connectSpeakerToBars(){
        let ds=this;
        console.log("Connecting speakers to bars")
        if(ds.speakerAudioContext){return}
        ds.destroyInstanceofSpeakers();
        // deviceManager.clearMicAudioContext();

        try {
            ds.speakerAudioContext = new AudioContext();
            const analyser = ds.speakerAudioContext.createAnalyser();
            const microphone = ds.speakerAudioContext.createMediaElementSource(this.testBarsAudio);
            const scriptProcessor = ds.speakerAudioContext.createScriptProcessor(2048, 1, 1);

            analyser.smoothingTimeConstant = 0.8;
            analyser.fftSize = 1024;

            microphone.connect(analyser);
            analyser.connect(scriptProcessor);
            scriptProcessor.connect(ds.speakerAudioContext.destination);
            scriptProcessor.onaudioprocess = function() {
                const array = new Uint8Array(analyser.frequencyBinCount);
                analyser.getByteFrequencyData(array);
                const arraySum = array.reduce((a, value) => a + value, 0);
                const average = arraySum / array.length;
                // console.log(Math.round(average));
                ds.colorSpeakerPids(average);
            };
        } catch (error) {
            console.error("Error connecting audio context",error)
        }

    };

    colorSpeakerPids(vol) {
        // console.log('Color speaker pid called ', vol)
        const allPids = [...document.querySelectorAll('.speaker-bar')];
        // console.log(allPids)
        const numberOfPidsToColor = Math.round(vol / 2);
        const pidsToColor = allPids.slice(0, numberOfPidsToColor);
        for (const pid of allPids) {
          pid.style.backgroundColor = "#e6e7e8";
        }
        for (const pid of pidsToColor) {
          // console.log(pid[i]);
          pid.style.backgroundColor = "#28a745";
        }
    };

    playTestAudio(){
        try {
            if(!this.selectedSpeakerId){
                this.speakerButton.addClass('pulse-button-red');
                this.setSpeakerError("No speakers selected. Please select speakers above and try again.")
                return
            }
            if(!this.speakerAudioContext){
                this.connectSpeakerToBars();
            }else{
                this.resumeSpeakersAudioContext();
            }
            this.testAudio.play();
            this.testBarsAudio.play();
            this.audioPlaying=true;
        } catch (error) {
            console.error('start audio error ', error);
        }
    }
    stopTestAudio(){
        try {
            this.testAudio.pause();
            this.testBarsAudio.pause();
            // this.testAudio.currentTime=0;
            // this.testBarsAudio.currentTime=0;
            this.audioPlaying=false;
            this.playerPlayPause.html(this.playIcon);
            // this.playerPlayPause.attr('title','Test Speakers');
            this.playerPlayPause.attr('data-original-title','Test Speakers')
            this.suspendSpeakersAudioContext();
            // this.testSpeakersButton.html(`${this.playAudioIcon} TEST SPEAKERS`);
        } catch (error) {
            console.error("stop audio error",error);
        }
    }

    async setSelectedSpeakerName(id){
        let name=await this.getDeviceName(id);
        let nameFormatted= name.length >= 37 ? name.slice(0,34)+"..." : name;
        this.speakerButton.html(`${nameFormatted} ${this.dropDownArrow}`)
    }

    async getDeviceName(id,type="audiooutput"){
        try {
            return new Promise((resolve,reject)=>{
               KinoJS.mediaDevices.enumerateDevices(devices=>{
                   for (let index = 0; index < devices.length; index++) {
                       const device = devices[index];
                       if (id == device.deviceId && device.kind==type) {
                           resolve(device.label);
                           return;
                       }
                   }
                   resolve(id);
               });
            });
        } catch (error) {
            return id;
        }
    };
    disableSpeakersNextButton(){
        console.log("Disable speakers nex button")
        this.speakersNextButton.attr('disabled','disabled');
    };

    enableSpeakersNextButton(){
        console.trace("Enable speaker next button");
        this.speakersNextButton.removeAttr('disabled');
    };

    setSpeakerError(message){
        this.speakerMessage.find(".msg-text").html(message);
        this.speakerMessage.removeClass('d-none');
    };
    clearSpeakerErrors(){
        this.speakerMessage.addClass('d-none');
        this.speakerMessage.find(".msg-text").html('');
    }

    //end of speaker functions


    listMicrophones(){
        this.microphonesList.html('<h6 class="dropdown-header px-2">Microphone devices</h6>');
        deviceManager.getMicrophones().then(microphones=>{

            if(!microphones || microphones.length==0){
                this.microphonesList.append($("<a/>",{
                    class:`dropdown-item lobby-dropdown-item`,
                    href:'#',
                    html:`No microphone found`
                }));
                return;
            }
            microphones.forEach(device=>{
                let selected="";
                if (this.selectedMicId == device.deviceId) {
                    selected = "selected";
                }
                let option=$("<a/>",{
                    class:`dropdown-item lobby-dropdown-item ${selected}`,
                    href:'#',
                    'device-id':device.deviceId,
                    html:`<i class="fas fa-microphone mr-1"></i> ${device.label}`
                }).on('click',(e)=>{
                    e.preventDefault();
                    this.tryMicrophoneDevice(device.deviceId);
                });
                this.microphonesList.append(option);
            })
        });
    };

    tryMicrophoneDevice(id){
        this.selectedMicId=id;
        deviceManager.getAudioTrack(id).then(audioTrack=>{
            if(this.capturedAudio){
                //stop previous captured mic
                this.stopTracks(this.capturedAudio);
            }
            this.capturedAudio=audioTrack[0];
            this.selectedMicId=audioTrack[0].deviceId;
            this.micDetectionFailed.addClass('d-none');
            this.clearMicErrors();
            this.hideMicBarsMovingPrompt();
            this.hideMicAfterConfirmMessage();
            this.disableMicNextButton();
            // deviceManager.saveMic(audioTrack[0].deviceId);
                this.playMicTestBars(this.capturedAudio).then(()=>{
                    if(this.micSelectionSection.hasClass('d-none')){
                        clearTimeout(this.detectingMicrophoneTimeout);
                        this.detectingMicrophoneTimeout=setTimeout(() => {
                            this.detectingMicMessage.addClass('d-none');
                            this.micSelectionSection.removeClass('d-none')
                            this.showMicBarsMovingPrompt();
                        }, 1500);
                    }else{
                        this.showMicBarsMovingPrompt();
                    }
                    // this.setMicError(`We could not not pick-up any sound from the microphone. Please select the microphone you would like to use.`)

                }).catch(()=>{
                    clearTimeout(this.detectingMicrophoneTimeout);
                    if(this.micSelectionSection.hasClass('d-none')){
                        this.detectingMicMessage.addClass('d-none');
                        this.micSelectionSection.removeClass('d-none')
                    }
                    this.showMicBarsMovingPrompt();
                    // this.micDetectionFailed.removeClass('d-none');
                    this.setMicError(`We could not not pick-up any sound from the microphone. Please select the microphone you would like to use.`)
                    this.microphoneButton.addClass('pulse-button-red');
                });

            this.setMicrophoneOn();
            this.listMicrophones();
            this.setSelectedMicrophoneName(this.capturedAudio.track.label);
        }).catch(err=>{
            this.setMicrophoneOff(err);
            if(this.micSelectionSection.hasClass('d-none')){
                this.detectingMicMessage.addClass('d-none');
                this.micSelectionSection.removeClass('d-none')
            }
        });
    };

    showMicBarsMovingPrompt(){
        this.hideMicAfterConfirmMessage();
        clearTimeout(this.micBarsConfirmTimeout);
        this.micBarsConfirmTimeout=setTimeout(() => {
            this.micBarsConfirm.removeClass('d-none');
        }, 1000);
        this.disableMicNextButton();
    };

    hideMicBarsMovingPrompt(){
        clearTimeout(this.micBarsConfirmTimeout);
        this.micBarsConfirm.addClass('d-none');
    };

    setMicAfterConfirmMessage(message){
        this.micAfterConfirmMessage.find(".wizard-label").html(message);
        this.micAfterConfirmMessage.removeClass('d-none');
    };

    hideMicAfterConfirmMessage(){
        this.micAfterConfirmMessage.addClass('d-none');
        this.micAfterConfirmMessage.find(".wizard-label").html('');
    }

    stopTracks(localTrack){
        try {
            if(!localTrack){return}
            if (localTrack._originalStream) {
                localTrack._originalStream.getTracks().forEach(t=>t.stop());
                localTrack._originalStream = undefined;
            }
            localTrack.stream.getTracks().forEach(t=>t.stop());
        } catch (error) {
            console.error("end tracks error",error);
        }
    }


    setMicrophoneOn(){
        this.clearMicErrors()
        // this.enableMicNextButton();
    };

    setMicrophoneOff(error=false){
        this.disableMicNextButton();
        if(error){
            this.micErrorHandler(error);
        }else{
            this.clearMicErrors();
        }
        this.destroyInstanceOfMics();
    };

    disableMicNextButton(){
        this.microphoneNextButton.attr('disabled','disabled');
    };

    enableMicNextButton(){
        this.microphoneNextButton.removeAttr('disabled');
    };

    setMicError(message){
        this.micMessage.find(".msg-text").html(message);
        this.micMessage.removeClass('d-none');
    };
    clearMicErrors(){
        this.micMessage.addClass('d-none');
        this.micMessage.find(".msg-text").html('');
    }
    micErrorHandler(error) {
        var dm = this;
        console.error("Failed to get media device", error.name);
        switch (error.name) {
            case "gum.general":
                dm.setMicError(`Can't access microphone`);
                break;
            case "NotAllowedError":
            case "gum.permission_denied":
                dm.setMicError(`Microphone permission denied`)
                break;
            case "NotFoundError":
            case "gum.not_found":
                dm.setMicError(`Can't find selected microphone`);
                break;
            case "OverconstrainedError":

            default:
                dm.setMicError(`Error getting microphone`);
                return;
                break;
        }
        if(error.message == 'Permission denied by system'){
            if(isMac){
                dm.setMicError(`
                    Please check the checkbox next to Kino icon in the Security & Privacy preferences. <br/>
                    Once checked, you can close the Security & Privacy preference window and continue using Kino.
                `);
                return;
            }
            if(isWindows){
                dm.setMicError(`
                    Grant access to Kino in Privacy & Security in order to use your microphone.<br/>
                    Once the permission is granted, you can close the Privacy & Security window and continue using Kino.
                `);
                return;
            }
        }
    };

    setSelectedMicrophoneName(name){
        console.log(`Microphone name length is`,name.length)
        let nameFormatted= name.length >= 33 ? name.slice(0,30)+"..." : name;
        this.microphoneButton.html(`${nameFormatted} ${this.dropDownArrow}`)
    }

    playMicTestBars(track){
        return this.connectMicToBars(track.stream);
    };

    connectMicToBars(stream){
        let ds=this;
        ds.destroyInstanceOfMics();
        return new Promise((resolve,reject)=>{
            let detectSoundTimeout=2000;
            let rejectTimeoutFunction=0;
            let promiseResolved=false;
            ds.audioContext = new AudioContext();
            const analyser = ds.audioContext.createAnalyser();
            const microphone = ds.audioContext.createMediaStreamSource(stream);
            const scriptProcessor = ds.audioContext.createScriptProcessor(2048, 1, 1);

            analyser.smoothingTimeConstant = 0.8;
            analyser.fftSize = 1024;

            microphone.connect(analyser);
            analyser.connect(scriptProcessor);
            scriptProcessor.connect(ds.audioContext.destination);
            scriptProcessor.onaudioprocess = function() {
                const array = new Uint8Array(analyser.frequencyBinCount);
                analyser.getByteFrequencyData(array);
                const arraySum = array.reduce((a, value) => a + value, 0);
                const average = arraySum / array.length;
                if(!promiseResolved && average > 0.1){
                    resolve();
                    promiseResolved=true;
                }
                // console.log(Math.round(average));
                ds.colorPids(average*2);
            };
            rejectTimeoutFunction=setTimeout(() => {
                reject();
                promiseResolved=true;
            }, detectSoundTimeout);
        });
    };

    colorPids(vol) {
        const allPids = [...document.querySelectorAll('.mic-bar')];
        const numberOfPidsToColor = Math.round(vol / 6);
        const pidsToColor = allPids.slice(0, numberOfPidsToColor);
        for (const pid of allPids) {
          pid.style.backgroundColor = "#e6e7e8";
        }
        for (const pid of pidsToColor) {
          // console.log(pid[i]);
          pid.style.backgroundColor = "#28a745";
        }
    };

    destroyInstanceOfMics(){
        let ds = this;
        if(ds.audioContext){
            ds.audioContext.close();
            ds.audioContext=null;
        }
        this.colorPids(0);
    }



    //camera functions
    listCameras(){
        this.camerasList.html('<h6 class="dropdown-header px-2">Camera devices</h6>');
        deviceManager.getCameras().then(cameras=>{
            if(!cameras || cameras.length==0){
                this.camerasList.append($("<a/>",{
                    class:`dropdown-item lobby-dropdown-item`,
                    href:'#',
                    html:`No camera found`
                }));
                return;

            }

            cameras.forEach(device=>{
                let selected='';
                if (device.kind == "videoinput") {

                    if (this.selectedCameraId == device.deviceId) {
                        selected = "selected";
                    }
                    let option=$("<a/>",{
                        class:`dropdown-item lobby-dropdown-item ${selected}`,
                        href:'#',
                        'device-id':device.deviceId,
                        html:`<i class="fas fa-video mr-1"></i> ${device.label}`
                    }).on('click',(e)=>{
                        e.preventDefault();
                        this.tryCameraDevice(device.deviceId);
                    });
                    this.camerasList.append(option);
                }
            });
        });
    };

    tryCameraDevice(id){
        deviceManager.getCameraTrack(id).then(async cameraTracks=>{
            console.log("Success getting camera track",cameraTracks[0]);
            this.selectedCameraId=cameraTracks[0].deviceId;
            if(this.capturedVideo){
                this.stopTracks(this.capturedVideo);
            }

            this.capturedVideo=cameraTracks[0];
            this.playCameraPreview();
            this.setCameraOn();
            this.setSelectedCameraName(this.capturedVideo.track.label);
        }).catch(err=>{
            console.error(err.message);
            this.setCameraOff(err);
        })
    };

    setCameraOn(){
        this.clearCamError();
    }
    setCameraOff(error){
        if(error){
            this.cameraErrorHandler(error);
        }else{
            if(this.cameraPreview)
            this.cameraPreview.srcObject=null;
            this.clearCamError();
        }
    };

    setCamError(message){
        this.cameraMessage.find('.msg-text').html(message);
        this.cameraMessage.removeClass('d-none')
    }
    clearCamError(){
        this.cameraMessage.addClass('d-none')
        this.cameraMessage.find('.msg-text').html('');
    }

    cameraErrorHandler(error) {
        var dm = this;
        console.error('error message: ', error.message);
        console.error("Failed to get media device", error.name);
        switch (error.name) {
            case "gum.general":
                    dm.setCamError(`We couldn't find your camera, make sure that your camera is connected and not being used by another app.`);
                break;
            case "NotReadableError":
                    dm.setCamError(`We couldn't find your camera, make sure that your camera is connected and not being used by another app.`);
                    deviceManager.resetCameraDevice((hasCameras=>{
                        if(hasCameras && !this.stopRetryCamera){
                            this.stopRetryCamera=true;
                            this.cameraDeviceId=deviceManager.lastUsedCamera();
                            this.tryCameraDevice(false);
                        }
                }));
                break;
            case "gum.unsupported_resolution":
                // dm.resetCameraDevice();
                // break;
            case "NotAllowedError":
            case "gum.permission_denied":
                dm.setCamError(`Camera access has been denied. Check for a camera icon in the browser's search bar, allow access, then refresh.`);

                break;
            case "NotFoundError":
            case "gum.not_found":
                dm.setCamError(`We couldn't find your camera, make sure that your camera is connected and not being used by another app.`);
                break;
            case "OverconstrainedError":

            default:
                dm.setCamError(`We couldn't access the camera. Please make sure the camera is connected and is not being used by another application. Try selecting the camera again from the drop down menu when ready.`);;
                return;
                break;
        }
        if(error.message == 'Permission denied by system'){
            if(isMac){
                dm.setCamError(`
                    Please check the checkbox next to Kino icon in the Security & Privacy preferences. <br/>
                    Once checked, you can close the Security & Privacy preference window and continue using Kino.
                `);
                return;
            }
            if(isWindows){
                dm.setCamError(`
                    Grant access to Kino in Privacy & Security in order to use your camera.<br/>
                    Once the permission is granted, you can close the Privacy & Security window and continue using Kino.
                `);
                return;
            }
        }
    };

    playCameraPreview(){
        try {
            if(this.capturedVideo){
                this.cameraPreview.srcObject=this.capturedVideo.stream;
            }
        } catch (error) {
            console.error(error);
        }
    };

    setSelectedCameraName(name){
        console.log(`Camera name length is`,name.length)
        let nameFormatted= name.length >= 33 ? name.slice(0,30)+"..." : name;
        this.cameraButton.html(`${nameFormatted} ${this.dropDownArrow}`)
    }

    setWizardShown(){
        localStorage.setItem('devices_wizard_shown','shown');
    }
};
